import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import withStyles from '../withStyles';
import styles from './MultiSelectFieldSearchBox.styles';
import Checkbox from '../Checkbox';
import ActionBar from '../ActionBar/v2';
import { isElementSelected } from '../../helpers';
import MultiSelectFieldSortSelect from './MultiSelectFieldSortSelect';
export class SearchBox extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isSearchMode: false,
            isSortMode: false,
        };
    }
    componentDidMount() {
        const { sortable, onSortChange } = this.props;
        const { sortMode } = this.state;
        const firstSortOption = sortable && sortable[0];
        if (firstSortOption && sortMode === undefined) {
            const defaultSortMode = {
                label: firstSortOption.label,
                by: firstSortOption.by,
                type: firstSortOption.type,
                isReverseSort: firstSortOption.defaultDirection === 'desc',
            };
            this.setState({ sortMode: defaultSortMode });
            onSortChange(defaultSortMode);
        }
    }
    render() {
        const { value, options, searchTerm, onChange, onSearchChange, onSortChange, disabled, classes, sortable, } = this.props;
        const { isSearchMode, isSortMode, sortMode } = this.state;
        const numChecked = options
            .map((option) => isElementSelected(value, option))
            .filter((c) => c).length;
        const checked = options.length > 0 && numChecked === options.length;
        const indeterminate = options.length > 0 && numChecked > 0 && numChecked < options.length;
        const showingValue = options.map((option) => option.props.value);
        const multiSelectAction = (_jsx(Checkbox, { className: classes.checkBox, disabled: disabled, checked: checked, indeterminate: indeterminate, onClick: (e) => {
                e.preventDefault();
                if (checked || indeterminate) {
                    onChange(value.filter((item) => !showingValue.includes(item)));
                }
                else {
                    const newValue = showingValue.filter((v) => !value.includes(v));
                    onChange([...value, ...newValue]);
                }
            } }));
        const onSortOptionSelect = (newSortMode) => {
            this.setState({ isSortMode: false, sortMode: newSortMode });
            onSortChange(newSortMode);
        };
        const sortAction = sortable && sortable.length > 0 && (_jsx(ActionBar.Select, Object.assign({ icon: _jsx(FilterListIcon, { className: classes.sortIcon }), open: isSortMode, onOpen: () => this.setState(({ isSortMode: prevIsSortMode }) => ({
                isSortMode: !prevIsSortMode,
            })), disabled: disabled }, { children: sortable.map((sortOption, index) => (_jsx(MultiSelectFieldSortSelect, { sortMode: sortMode, sortOption: sortOption, onSelect: onSortOptionSelect }, index))) })));
        const searchAction = isSearchMode ? (_jsx(ActionBar.Input, { autoFocus: true, label: "Search", disabled: disabled, maxWidth: 145, className: classes.searchInput, icon: _jsx(ActionBar.Action, { icon: _jsx(CloseIcon, { className: classes.closeIcon }), onClick: (e) => {
                    e.preventDefault();
                    this.setState({ isSearchMode: false });
                    onSearchChange('');
                } }), value: searchTerm, onChange: onSearchChange })) : (_jsx(ActionBar.Action, { className: classes.searchInputWrapper, icon: _jsx(SearchIcon, { className: classes.searchIcon }), disabled: disabled, onClick: () => this.setState({ isSearchMode: true, isSortMode: false }) }));
        return (_jsxs(ActionBar, Object.assign({ className: classes.searchBox }, { children: [multiSelectAction, !isSearchMode && sortAction, searchAction] })));
    }
}
SearchBox.defaultProps = {
    value: [],
    options: [],
    searchTerm: '',
    disabled: false,
    sortable: [],
};
export default withStyles(styles)(SearchBox);
//# sourceMappingURL=MultiSelectFieldSearchBox.js.map